import cx from 'classnames';

import './styles.scss';

type Props = {
    className?: string;
    svgClassName?: string;
    colorClassName?: string;
    strokeWidth?: number;
    absolute?: boolean;
}

export const Loader: React.FC<Props> = ({
    className, svgClassName, colorClassName = 'tw-text-primary-light', strokeWidth = 1, absolute = true
}: Props) => (
    <div className={cx(className, 'vs-loader loader', {absolute})}>
        <svg className={cx(svgClassName, colorClassName, 'circular-loader tw-w-full tw-h-full')} viewBox='25 25 50 50'>
            <circle className='loader-path' cx='50' cy='50' r={(50 - strokeWidth) / 2} strokeWidth={strokeWidth} />
        </svg>
    </div>
);